// Site content data for BOOST! Design & Marketing
// Contact form submissions are handled via backend API (see Contact.jsx)

export const BRAND = {
  name: 'BOOST!',
  sub: 'DESIGN & MARKETING',
  slogan: 'Giving your brand lift-off!',
  email: 'team@boostmarketing.agency',
  address: '27 Fairycroft Road, Saffron Walden, CB10 1LZ, UK',
  logo: 'https://customer-assets-lqy194kg.emergentagent.net/job_31bcde7c-d98a-4c27-a3ab-d96f08806001/artifacts/e3mvklhv_Logo%20Pink.png',
  rocket: 'https://customer-assets-lqy194kg.emergentagent.net/job_31bcde7c-d98a-4c27-a3ab-d96f08806001/artifacts/2yczwxnz_Favicon.jpg',
  social: {
    facebook: 'https://www.facebook.com/boostmarketingagency/',
    instagram: 'https://www.instagram.com/boostmarketinguk/',
    linkedin: 'https://www.linkedin.com/company/boostmarketinguk/',
  },
};

export const NAV_LINKS = [
  { label: 'AI Systems', href: '#ai' },
  { label: 'Missions', href: '#services' },
  { label: 'Success Stories', href: '#success' },
  { label: 'Launch Sequence', href: '#process' },
  { label: 'Toolkit', href: '#tools' },
  { label: 'Contact', href: '#contact' },
];

export const CLIENT_SUCCESS = {
  client: 'Diamondbrite',
  parent: 'Jewelultra Ltd',
  industry: 'Vehicle care & paint protection · UK',
  intro:
    'Diamondbrite is one of the UK\u2019s leading names in vehicle care and paint protection. What began as creative support has evolved into a true strategic alliance \u2014 and the results speak for themselves.',
  before: { year: '2022', rating: '2.8', reviews: '4 reviews' },
  after: { year: '2025', rating: '4.9', reviews: '422+ reviews' },
  stats: [
    { value: '4.9\u2605', label: 'Google rating \u2014 up from 2.8\u2605' },
    { value: '105x', label: 'More Google reviews' },
    { value: '\u00a31000s', label: 'Saved with 3D product renders' },
    { value: 'Hours', label: 'Saved weekly by AI chatbot' },
  ],
  achievements: [
    {
      id: 'reputation',
      icon: 'Star',
      title: 'Reputation, Transformed',
      description:
        'Our automated review invitation system \u2014 with a thank-you discount after every purchase \u2014 took Diamondbrite from 4 Google reviews at 2.8\u2605 to 422+ at 4.9\u2605, now among the best in the industry. Every single review gets a personalised reply, compounding SEO visibility and trust.',
      featured: true,
    },
    {
      id: 'ecommerce',
      icon: 'ShoppingCart',
      title: 'Ecommerce That Performs',
      description:
        'A points & rewards loyalty scheme, DHL fulfilment automation, a TreeNation sustainability partnership, an AI chatbot saving hours of office time every week, and a dynamic store with seasonal promotions and real-time updates.',
      featured: true,
    },
    {
      id: 'brand',
      icon: 'Gem',
      title: 'A Modern Brand Identity',
      description:
        'A dedicated brand website with ongoing optimisation, event & POS design, chrome-effect Graphene labels, new training certificates \u2014 and photo-realistic 3D renders that saved thousands in photography costs.',
    },
    {
      id: 'marketing',
      icon: 'Megaphone',
      title: 'Full-Funnel Marketing',
      description:
        'Email campaigns with measurable sales impact, welcome journeys with coupons and guarantee info, social media strategy & content, SEO-rich YouTube optimisation, and Google & Facebook Ads management.',
    },
    {
      id: 'data',
      icon: 'Database',
      title: 'Data, Insights & Sales Support',
      description:
        'Clean, well-maintained databases, accurate analytics, a unified sales presentation with updated visuals, and continuous improvement through proactive initiatives.',
    },
    {
      id: 'product',
      icon: 'BadgeCheck',
      title: 'Product Identity, Led By Us',
      description:
        'BOOST! independently created the NanoCeramic logo for the Advanced Ceramic line \u2014 an initiative that has since been adopted across all Diamondbrite packaging and marketing materials.',
    },
  ],
  quote:
    'We don\u2019t act like an agency \u2014 we act like part of the team. Diamondbrite\u2019s wins are our wins: a stronger brand, stronger sales, and a stronger future.',
};

export const TEMPLE_SUCCESS = {
  code: '// MISSION REPORT 02: FULL-STACK BUILD',
  client: 'Temple of Sound Distribution',
  industry: 'Music retail & distribution · UK',
  url: 'https://www.templeofsound.co.uk',
  intro:
    'For the UK\u2019s premier drum product distributor \u2014 home of London Drumstick Company and Alchemist Cymbals \u2014 we designed and built a complete retail platform from the ground up. Every feature 100% bespoke: no templates, no plugins, no compromises.',
  stats: [
    { value: '15K+', label: 'Cymbals in the store' },
    { value: '14K+', label: 'Drumstick configurations' },
    { value: '2', label: 'Bespoke loyalty currencies' },
    { value: '200+', label: 'Retailers & artists served' },
  ],
  features: [
    {
      id: 'shop',
      icon: 'ShoppingBag',
      title: 'Full B2C Shop',
      description:
        'A complete ecommerce experience across two brands \u2014 series collections, product discovery and secure Stripe checkout for thousands of products.',
    },
    {
      id: 'b2b',
      icon: 'Briefcase',
      title: 'Bespoke B2B Trade & Artist Portal',
      description:
        'A dedicated portal with wholesale pricing, custom quoting tools, bulk ordering and account management \u2014 trusted by 200+ retailers and professional artists worldwide.',
    },
    {
      id: 'membership',
      icon: 'Crown',
      title: 'Membership System',
      description:
        'Three-tier subscription programme (Free, Pro, VIP) with tiered discounts, loyalty multipliers, early access to product drops and Stripe-powered billing.',
    },
    {
      id: 'rewards',
      icon: 'Coins',
      title: 'Points & Rewards Engine',
      description:
        'Two custom loyalty currencies \u2014 Gold Dust for cymbals, Beat Tokens for drumsticks \u2014 with redemption tiers, point multipliers and a built-in referral scheme.',
    },
    {
      id: 'studio',
      icon: 'Wand2',
      title: 'Creative Studio',
      description:
        'An interactive custom drumstick builder where players configure wood, tip, balance and finish to their exact specification \u2014 14K+ possible combinations.',
    },
    {
      id: 'content',
      icon: 'MonitorPlay',
      title: 'Content & Video Hub',
      description:
        'Artist videos, product demos, WhatsApp chat integration and a full FAQ knowledge base \u2014 keeping drummers engaged well beyond checkout.',
    },
  ],
};

export const AI_PLATFORMS = [
  'ChatGPT · OpenAI',
  'Claude · Anthropic',
  'Gemini · Google',
  'Emergent',
  'Copilot · Microsoft',
  'Perplexity',
];

export const AI_FEATURES = [
  {
    id: 'assistants',
    icon: 'Bot',
    title: 'Custom AI Assistants & Chatbots',
    description:
      'Assistants trained on your business — built on ChatGPT and Claude — that answer questions, qualify leads and support your customers 24/7. Your best team member never sleeps.',
    featured: true,
  },
  {
    id: 'workflows',
    icon: 'Workflow',
    title: 'AI-Powered Workflows',
    description:
      'We wire AI into the tools you already use — Airtable, Zapier, Make and more — so emails draft themselves, data organises itself, and hours of busywork simply disappear.',
    featured: true,
  },
  {
    id: 'geo',
    icon: 'Satellite',
    title: 'GEO & AI Search Visibility',
    description:
      'Search has changed — your next customer is asking ChatGPT, Claude, Perplexity or Gemini for recommendations. We optimise your brand to be found and cited in AI answers with GEO (Generative Engine Optimisation): AI-optimised content strategies, structured data, technical GEO audits and LLM visibility tracking — supercharged by specialist platforms like BabyLoveGrowth.',
    featured: true,
  },
  {
    id: 'apps',
    icon: 'Rocket',
    title: 'Rapid AI App Building',
    description:
      'Fully custom AI applications built at startling speed with platforms like Emergent — from internal dashboards and portals to customer-facing products. Weeks, not months.',
  },
  {
    id: 'content',
    icon: 'PenTool',
    title: 'AI Content Engines',
    description:
      'On-brand content systems that generate blogs, product descriptions, emails and social posts on demand — always with a human polish before anything ships.',
  },
  {
    id: 'strategy',
    icon: 'GraduationCap',
    title: 'AI Strategy & Training',
    description:
      'Not sure where to start? We audit your business, pinpoint the highest-impact AI opportunities, then train your team to use them with total confidence.',
  },
];

export const FAQS = [
  {
    q: 'What does BOOST! Design & Marketing do?',
    a: 'BOOST! is a full-service design, marketing and AI agency. We cover AI systems & workflow automation, graphic & brand design, web design, social media management, SEO & marketplace optimisation, email marketing, no-code automation and IT services — one crew for everything your brand needs to grow.',
  },
  {
    q: 'Can BOOST! build AI systems for my business?',
    a: 'Absolutely — it\u2019s one of our flagship services. We build custom AI assistants and chatbots powered by ChatGPT and Claude, AI-driven workflows connected to tools like Airtable, Zapier and Make, and full AI applications built rapidly with platforms like Emergent. We also offer AI strategy audits and team training.',
  },
  {
    q: 'What is an AI workflow, and how can it help my business?',
    a: 'An AI workflow connects artificial intelligence to your everyday processes — so things like replying to enquiries, drafting emails, summarising documents, categorising data and creating content happen automatically. Most businesses save hours every week from the very first workflow we build.',
  },
  {
    q: 'What is GEO (Generative Engine Optimisation), and do you offer it?',
    a: 'GEO is the new frontier of search: optimising your brand to be found, cited and recommended by AI assistants like ChatGPT, Claude, Perplexity and Gemini — where more and more of your customers now ask for recommendations. Yes, we offer it! We combine AI-optimised content strategies, structured data, technical GEO audits and LLM visibility tracking, supercharged by specialist platforms like BabyLoveGrowth. And we practise what we preach — this very website is GEO-optimised.',
  },
  {
    q: 'What platforms do you use for web design?',
    a: 'We design and build with WordPress, Elementor, WooCommerce and Shopify — from eye-popping landing pages to fully-equipped ecommerce stores.',
  },
  {
    q: 'Do you handle Amazon and eBay optimisation?',
    a: 'Yes! We have years of experience optimising Amazon and eBay listings — including Amazon A+ content — helping clients generate more sales and climb the rankings.',
  },
  {
    q: 'How do I get started with BOOST!?',
    a: 'Just email team@boostmarketing.agency or fill in the contact form on this page. Tell us about your brand and your goals, and we\u2019ll plot the flight path — we reply within 24 hours.',
  },
];

export const SERVICES = [
  {
    id: 'design',
    icon: 'Palette',
    code: 'M-01',
    title: 'Design',
    tagline: 'Pixel-perfect creativity',
    description:
      'We have expertise in many areas of design and content creation — from brand identities to scroll-stopping visuals.',
    items: ['Graphic Design', 'Brand Design', 'Logo Design', 'Amazon A+', 'Content Creation', 'Ecommerce Images'],
    big: true,
  },
  {
    id: 'web',
    icon: 'Globe',
    code: 'M-02',
    title: 'Web Design',
    tagline: 'Sites of your dreams',
    description:
      "Whether it's an eye-popping landing page or a fully-equipped ecommerce store — we can build it!",
    items: ['WordPress', 'Elementor', 'WooCommerce', 'Shopify'],
    big: true,
  },
  {
    id: 'social',
    icon: 'Share2',
    code: 'M-03',
    title: 'Social Media',
    tagline: "Let's talk socials",
    description:
      'Advertising strategy and campaigns, content pillars and planning, or fully-fledged social media management.',
    items: ['Strategy & Campaigns', 'Content Creation', 'Full Management'],
  },
  {
    id: 'seo',
    icon: 'Search',
    code: 'M-04',
    title: 'SEO, GEO & Optimisation',
    tagline: 'Found by Google & by AI',
    description:
      'Classic SEO plus GEO (Generative Engine Optimisation) — so your brand is found on Google and recommended by AI assistants. We also optimise Amazon & eBay listings to maximise sales.',
    items: ['Website SEO', 'GEO / AI Search', 'Amazon Listings', 'eBay Listings'],
  },
  {
    id: 'email',
    icon: 'Mail',
    code: 'M-05',
    title: 'Email & Funnels',
    tagline: 'Emails that convert',
    description:
      'Attention-grabbing newsletters, automated promotions, timed offers and transactional emails that keep customers coming back.',
    items: ['Newsletters', 'Automated Campaigns', 'Sales Funnels'],
  },
  {
    id: 'automation',
    icon: 'Workflow',
    code: 'M-06',
    title: 'Automation & No-Code',
    tagline: 'Automation is KEY',
    description:
      'We tailor workflow solutions with Airtable, Zapier, Make & more — CRMs, portals, inventory tracking, the lot.',
    items: ['Airtable', 'Zapier', 'Make', 'Softr', 'CRM Systems'],
  },
  {
    id: 'it',
    icon: 'Server',
    code: 'M-07',
    title: 'IT Services',
    tagline: 'Your digital ground crew',
    description:
      'From web hosting to full cloud email set-up and management — our skilled technicians look after your digital world.',
    items: ['Web Hosting', 'Cloud Email', 'Remote Servers', 'Storage'],
  },
];

export const PROCESS_STEPS = [
  {
    count: '3',
    title: 'Discover',
    description:
      'We dig deep into your brand, your goals and your audience. Every great launch starts with a flight plan.',
  },
  {
    count: '2',
    title: 'Design & Build',
    description:
      'Our crew crafts your visuals, website, campaigns and automations — engineered to perform, built to impress.',
  },
  {
    count: '1',
    title: 'Launch',
    description:
      'We hit the big red button. Your brand goes live with everything tested, tuned and ready for maximum thrust.',
  },
  {
    count: '🚀',
    title: 'Orbit & Grow',
    description:
      'Post-launch we monitor, optimise and iterate — keeping your brand in orbit and climbing higher.',
    isLiftOff: true,
  },
];

export const TOOLS = [
  'ChatGPT', 'Claude', 'Gemini', 'Emergent', 'BabyLoveGrowth', 'WordPress', 'Elementor',
  'WooCommerce', 'Shopify', 'Airtable', 'Zapier', 'Make', 'Softr', 'Stacker',
  'Trello', 'Loomly', 'Instagram', 'Facebook', 'X / Twitter', 'AWS',
  'Google Workspace', 'Office 365', 'Hostinger',
];

export const STATS = [
  { value: '8+', label: 'Mission Specialities' },
  { value: 'AI', label: 'Built Into Everything' },
  { value: '∞', label: 'Creative Fuel' },
  { value: '24/7', label: 'Mission Control' },
];

export const SERVICE_OPTIONS = [
  'AI Systems & Workflows',
  'Design',
  'Web Design',
  'Social Media',
  'SEO, GEO & AI Search',
  'Email Marketing & Funnels',
  'Automation & No-Code',
  'IT Services',
  'Something else…',
];
